import { Outlet } from "react-router-dom";
import { Sidebar, HeaderAdmin } from "../components";
const PrivateLayout = () => {
  return (
    <div className="flex  h-[100vh] ">
      <Sidebar />
      <div className="p-2 md:p-4 xl:p-6 overflow-y-auto  w-full">
        <Outlet />
      </div>
    </div>
  );
};

export default PrivateLayout;
